module.exports = __webpack_public_path__ + "static/media/success.0dd68d57.mp3";